export const globalTranslateStatusReadJust = (status: string = ""): string => {
	const traduzir = status.toLowerCase();
	if (traduzir === "active") {
		return "Ativo";
	}
	if (traduzir === "inactive") {
		return "Inativo";
	}
	if (traduzir === "empty") {
		return "Usuario";
	}
	if (traduzir === "system") {
		return "Sistema";
	}

	return traduzir;
};


